export default "__VITE_ASSET__BpFZlALm__"